module.exports = __webpack_public_path__ + "static/media/GM-Cabs-card-logo.5bdfac93.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/GM-Cabs-card-logo.jpg
// module id = 76
// module chunks = 0